"use strict";

import angular from "angular";

angular
    .module("nucont.accounting.company.department")
    .config(["$stateProvider", routeConfig]);

function routeConfig($stateProvider) {
    $stateProvider
        .state("nucont.accounting.company.department.personnel", {
            url: "/pessoal?accountPlanType",
            params: { accountPlanType: { value: null, dynamic: true } }
        })
        .state("nucont.accounting.company.department.personnel.import", {
            url: "/importar",
            views: {
                "tableDepartment@nucont.accounting.company.department": {
                    component: "departmentPersonnelImportComponent",
                    bindings: { companyData: "CompanyData" }
                }
            },
            bodyClass: "department-module"
        })
        .state("nucont.accounting.company.department.personnel.edit", {
            url: "/editar",
            views: {
                "tableDepartment@nucont.accounting.company.department": {
                    component: "departmentPersonnelEditComponent",
                    bindings: { companyData: "CompanyData" }
                }
            },
            bodyClass: "department-module"
        })
        .state("nucont.accounting.company.department.personnel.scenarios", {
            url: "/cenarios/:scenarioId",
            params: {
                scenarioId: { value: null, dynamic: true }
            },
            views: {
                "tableDepartment@nucont.accounting.company.department": {
                    component: "departmentPersonnelScenariosComponent",
                    bindings: { companyData: "CompanyData" }
                }
            },
            bodyClass: "department-module"
        })
        .state("nucont.accounting.company.check.personnel", {
            url: "/pessoal",
            lazyLoad(transition) {
                const $ocLazyLoad = transition.injector().get("$ocLazyLoad");
                return import(
                    /* webpackChunkName: "feature-accounting-company-department" */ "../department.entry"
                ).then(() =>
                    $ocLazyLoad.inject("nucont.accounting.company.department")
                );
            },
            views: {
                "admin@nucont.accounting": {
                    component: "departmentPersonnelCheckComponent",
                    bindings: { companyData: "CompanyData" }
                }
            },
            bodyClass: "department-module"
        });
}
